export const AUTH_SESSION_KEY = 'AUTH_SESSION';
export const OAUTH_REDIRECT_KEY = 'OAUTH_REDIRECT';
export const LAST_VISITED_PATH_KEY = 'LAST_VISITED_PATH';
